///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-optimized-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportDP005Product = Meevo.Plugins.Reports.IReportDP005Product;

    interface ICriteria {
        ProductState_TBL?: string[];
        ProductCat_TBL?: string[];
        ProductCatList_TBL?: string[];
        ManufacturerList_TBL?: string[];
        OnlyProductsCreatedOrUpdatedByCurrentUser?: boolean;
        OnlyProductsCreatedOrUpdatedToday?: boolean;
    }

    export class ReportDp005ProductVariantsCollection extends CollectionOptimizedApi<IReportDP005Product> implements IApiCollection<IReportDP005Product> {

        protected get url() {
            return 'report/DP005Product';
        }

        protected criteria: ICriteria;

        protected criteriaIsValid(): boolean {
            return this.criteria.ProductState_TBL instanceof Array
                && this.criteria.ProductCat_TBL instanceof Array
                && this.criteria.ProductCatList_TBL instanceof Array
                && this.criteria.ManufacturerList_TBL instanceof Array
                && typeof this.criteria.OnlyProductsCreatedOrUpdatedByCurrentUser === 'boolean'
                && typeof this.criteria.OnlyProductsCreatedOrUpdatedToday === 'boolean'
                ;
        }
    }

}
